"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var _1 = require(".");

var image_1 = require("../util/image");

require("./form.less");

var Upload = function (_super) {
  __extends(Upload, _super);

  function Upload(props) {
    var _this = _super.call(this, props) || this;

    _this.onImage = _this.onImage.bind(_this);
    return _this;
  }

  Upload.prototype.onValue = function (field, value, isValid) {};

  Upload.prototype.onAction = function (action) {
    switch (action) {
      case "upload":
        var fileInput = this.refs.fileInput;
        fileInput.click();
        break;

      default:
        console.error(action);
    }
  };

  Upload.prototype.onImage = function (event) {
    var input = event.currentTarget;
    var context = this.props.context;
    var field = this.props.field;
    var length = input.files.length;

    for (var index = 0; index < length; index++) {
      var file = input.files[index];
      context.onValue(field, file, true);
    }
  };

  Upload.prototype.render = function () {
    var _this = this;

    return React.createElement("div", {
      className: "upload"
    }, React.createElement("input", {
      type: "file",
      multiple: !!this.props.multiple,
      ref: "fileInput",
      style: {
        display: "none"
      },
      accept: this.props.accept || "*",
      onChange: this.onImage
    }), function () {
      if (_this.props.children) {
        return React.Children.map(_this.props.children, function (child) {
          return React.cloneElement(child);
        });
      } else if (_this.props.buttonOnly) {
        return React.createElement(_1.Button, {
          className: "box-shadow-button",
          action: "upload",
          context: _this
        }, "Select File");
      } else {
        return React.createElement(DefaultUploader, {
          context: _this
        });
      }
    }());
  };

  return Upload;
}(React.Component);

exports["default"] = Upload;

var DefaultUploader = function (_super) {
  __extends(DefaultUploader, _super);

  function DefaultUploader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DefaultUploader.prototype.render = function () {
    return React.createElement("div", {
      className: "boxed",
      style: {
        background: "#f9fafc"
      }
    }, React.createElement(_1.Button, {
      small: true,
      primaryGradient: true,
      action: "upload",
      context: this.props.context
    }, "Upload"), React.createElement("p", {
      className: "type--fine-print"
    }, "Please upload up to 12 .jpeg, .jpg and/or .png files smaller than 10MB."));
  };

  return DefaultUploader;
}(React.Component);

var CloudImage = function (_super) {
  __extends(CloudImage, _super);

  function CloudImage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CloudImage.prototype.render = function () {
    var _this = this;

    return React.createElement(image_1["default"], {
      aspectRatio: "1:1",
      content: this.props.value
    }, React.createElement(image_1.Overlay, {
      hoverOnly: true
    }, React.createElement("div", {
      className: "remove",
      onClick: function onClick() {
        return _this.props.onRemove(_this.props.value);
      }
    }, React.createElement("i", {
      className: "icon-Cloud-Remove"
    }), React.createElement("div", null, "Remove"))));
  };

  return CloudImage;
}(React.Component);

exports.CloudImage = CloudImage;